import React, { createContext, useEffect, useState } from 'react';
import { LOCAL_STORAGE_KEY } from 'constants/LocalStorageKeys';
import { getDataFromLocalStorage } from 'utils/LocalStorage';

const initialState = null;

export const UserContext = createContext({
  userData: initialState,
  setUserData: () => null,
});

export function UserProvider({ children }) {
  const [userData, setUserData] = useState(initialState);

  useEffect(() => {
    if (!userData && getDataFromLocalStorage(LOCAL_STORAGE_KEY.accessToken)) {
      const userProfile = getDataFromLocalStorage(LOCAL_STORAGE_KEY.profile);
      setUserData(userProfile);
    }
  }, [userData]);

  return (
    <UserContext.Provider
      value={{
        userData,
        // @ts-ignore
        setUserData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
